import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  TypeBlock,
  FeatureList,
  UsageSteps,
  VideoBlock,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';

const TubularMarker = () => {
  

  const features = [
    {
      title: '우수한 탄성 복원력',
      bullets: [
      {
        label: (
          <>고탄성 소재를 적용해 차량이 충돌하더라도 신속하게 원상 복구되며, 반복 충격에도 구조 변형이 적어 장기간 사용할 수 있음</>
        ),
      },
      ]
    },
    {
      title: '뛰어난 시인성',
      bullets: [
      {
        label: (
          <>고휘도 반사판과 고대비 색상(주황·형광 등)을 사용해 야간·우천·안개 등 시야가 제한된 상황에서도 차로를 명확하게 인지할 수 있음</>
        ),
      },
      ]
    },
    {
      title: '안전한 차로 분리 및 유도',
      bullets: [
      {
        label: (
          <>차량의 차선 침범 방지, 회전 차로 유도, 공사구간 및 위험지역 접근 방지 등 다양한 상황에서 안정적인 차선 규제가 가능함</>
        ),
      },
      ]
    },
    {
      title: '간편한 설치 및 교체',
      bullets: [
      {
        label: (
          <>베이스 고정형 또는 앵커 방식으로 누구나 빠르게 설치할 수 있으며, 규제봉만 단독 교체가 가능해 유지보수 비용 절감이 가능함</>
        ),
      },
      ]
    },
    {
      title: '다양한 규격 및 환경 대응',
      bullets: [
      {
        label: (
          <>규격별 높이·두께 선택이 가능하며, 도로 형태·현장 상황·공사구간 특성에 맞춘 맞춤형 적용이 가능함</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`차선규제봉`}
        subtitle={`차로 분리, 차량 유도, 위험 구간 보호 기능을 \n제공합니다`}
        backgroundImage="/images/products/traffic-safety/tubular-marker4.jpg"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '차선규제봉' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`안정적인 차로 안내를 위해`}
        title={`차선규제봉`}
        description={
          <>
            차로 분리, 차량 유도, 위험 구간 보호를 위해 설치되는 탄성 안전시설로, {' '}
            차량 충돌 시에도 원형으로 복원되는 구조를 갖춘 도로 교통안전 장비입니다.
            <br />
            <br />
            인성이 뛰어난 색상과 반사체를 적용하여 주·야간 모두 안정적인 차로 안내 기능을 제공합니다.
          </>
        }
        images={[
          '/images/products/traffic-safety/tubular-marker3.png',
        ]}
      />

      <SectionDivider />


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="traffic-safety"
        currentPath="/products/traffic-safety/tubular-marker"
        listPath="/products/traffic-safety"
      />


      <CTASection />
    </>
  );
};

export default TubularMarker;
